
<div class="">
  @if (Mode == 'polygon' && Editable) {
    <button class="button is-small is-light" (click)="ResetPolygon()">Reset Shape</button>
  }
  @if (Mode == 'polygon' && Editable) {
    <button class="button is-small is-light" (click)="RecenterPolygon()">Center Shape on Map</button>
  }
  @if (Mode == 'marker' && Editable) {
    <button class="button is-small is-light" (click)="RecenterMarker()">Center Marker on Map</button>
  }
</div>

<google-map [width]="MapWidth" [height]="MapHeight"  [zoom]="Zoom" [options]="MapOptions">
  @for (p of BackgroundPolygons; track p) {
    <map-polygon [paths]="p.paths" [options]="{strokeColor : '#555', fillColor : '#555'}" ></map-polygon>
  }
  @for (p of BackgroundMarkers; track p) {
    <map-marker [position]="p.position" [label]="p.label" [icon]="p.icon"  [options]="{ clickable: true  }" (mapClick)="BackgroundMarkerClick(p)" ></map-marker>
  }
  @if (Polygon != null) {
    <map-polygon #polygon  [paths]="Polygon" [options]="{ strokeColor: '#007237', fillColor: '#007237', editable: Editable, draggable: Editable }" (polygonMouseup)="EditPolygonMouseUp($event)" ></map-polygon>
  }
  @if (Marker != null) {
    <map-marker #marker [position]="Marker" [icon]="MarkerIcon" [options]="{ draggable:  true }" (mapDragend)="EditMarkerDragged($event)" ></map-marker>
  }
</google-map>